<template>
  <div class="app-container">
    <navigation title="读者问卷调查"></navigation>
    <div class="main">
      <div class="thank" v-if="isShow">
        <img src="../../assets/img/collect.png" alt="" class="thank-img">
        <div class="parsing-text">感谢你参与我们的问卷调查</div>
        <div class="suffix" v-if="suffix">
          {{suffix}}
        </div>
      </div>
      <div class="parsing"  v-else="false">
        <div class="parsing-thank">
          <img src="../../assets/img/collect.png" alt="" class="parsing-img">
          <div class="parsing-text">感谢你参与我们的问卷调查</div>
        </div>
        <div class="suffix" v-if="suffix">
            {{suffix}}
        </div>
        <div class="parsing-main">
          <div class="parsing-title">题目解析</div>
          <div class="parsing-list" v-for="item in list" v-if="item.questionDesc">
            <div class="parsing-list-title">{{ item.questionName }}<span class="parsing-list-type" v-if="item.questionType===2">（多选）</span></div>
            <div class="parsing-list-content">
              <span class="parsing-list-answer">解析:</span>
              {{ item.questionDesc }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, NavBar, Cell, CellGroup } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup)

export default {
  name: 'questionList',
  components: {navigation, version},
  data () {
    return {
      baseUrl: process.env.API_ROOT,
      list: [],
      suffix: '',
      isShow: true
    }
  },
  created () {
    this.getMessage()
  },
  methods: {
    getMessage(){
      let params = {
        id: this.$route.query.id
      }
      request('get', '/nlc-web/api/questionInfo/getDesc', params).then(res => {
        console.log('获取答案解析', res)
        if(res.code==200){
          this.suffix = res.data.suffix
          res.data.questionInfoList.forEach(item=>{
            if(item.questionDesc){
              this.isShow = false
            }
          })
          this.list = res.data.questionInfoList
        }
      })
    }
  }
}
</script>

<style scoped>
.app-container{
  width:100%;
  background:#ECF5FD;
  overflow-y:scroll;
  min-height: calc(100% - 92px);
  position: absolute;
  top: 0px;
  bottom: 0px;
}
.main{
  margin:.92rem 0 0 0;
  min-height: calc(100% - 92px);
}
.parsing-thank{
  width:100%;
  text-align:center;
  padding:.58rem 0;
}
.parsing-img{
  width:2.1rem;
  height:2.46rem;
}
.parsing-text{
  font-size: .32rem;
  font-weight: 400;
  color: rgba(70, 72, 75, 0.5);
}
.parsing-main{
  margin:.25rem .28rem;
}
.parsing-title{
  color:#008095;
  font-size: .36rem;
  font-weight: 500;
}
.parsing-list{
  margin:.25rem 0;
  background:#fff;
  border-radius: 8px;
  padding:.35rem .25rem;
}
.parsing-list-title{
  font-size: .36rem;
  font-weight: 400;
  color: #46484B;
}
.parsing-list-type{
  color:#008095;
}
.parsing-list-content{
  font-size: .28rem;
  font-weight: 400;
  color: #46484B;
  text-align: justify;
  line-height:.45rem;
  margin-top:.22rem;
}
.parsing-list-answer{
  font-weight: 500;
}
.thank{
  padding-top:3.38rem;
  text-align:center;
}
.thank-img{
  width:3.27rem;
  height:3.85rem;
}
.suffix{
  width:88%;
  background:#fff;
  margin:.25rem 3%;
  font-size:.3rem;
  border-radius: 8px;
  padding:.25rem 3%;
  text-align:left;
  color: #46484B;
}
</style>



// WEBPACK FOOTER //
// src/view/parsing/index.vue